import {
    Component,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
    AfterViewInit
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';

import {Constants} from '../../../shared/config/constants.config';
import {UsersService} from '../../../shared/services/users.service';
import {RecipesComponent} from '../../../recipes/components/news/recipes.component';
import {ProfilesComponent} from '../profiles/profiles.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {MasterService} from '../../../shared/services/master.service';
import {NotificationsService} from '../../../shared/services/notification.service';

@Component({
    selector: 'app-profiles-create-modal',
    templateUrl: './profiles-create.component.html',
    styleUrls: ['./profiles-create.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfilesCreateModalComponent implements AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;
    profilesComponent: ProfilesComponent;

    loginForm: FormGroup = new FormGroup({
        first_name: new FormControl('', [Validators.required, Validators.minLength(5)]),
        last_name: new FormControl('', [Validators.required, Validators.minLength(5)]),
        email: new FormControl('', [Validators.required, Validators.minLength(5), Validators.email]),
        password: new FormControl('', [Validators.required, Validators.minLength(5)])
    });

    constructor(
        public readonly bsModalRef: BsModalRef,
        public readonly constants: Constants,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly masterService: MasterService,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly notificationService: NotificationsService,
    ) {
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnInit() {

    }

    onClose() {
        this.bsModalRef.hide();
    }

    onCreate() {
        const first_name: string = this.loginForm.controls['first_name'].value;
        const last_name: string = this.loginForm.controls['last_name'].value;
        const email: string = this.loginForm.controls['email'].value;
        const password: string = this.loginForm.controls['password'].value;

        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.masterService.createProfile(first_name, last_name, email, password).subscribe(() => {
            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            this.onClose();

            setTimeout(() => {
                this.profilesComponent.ngOnInit();
            }, 500);
        }, (err: HttpErrorResponse) => {
            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);

            if (err.error === 'validator') {
                this.notificationService.error('Моля, въведете всички полета!');
            } else {
                this.notificationService.error('Потребител с този имейл вече съществува!');
            }
        });
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

}
